import React from "react";
import { hasPermissionSync } from "../utils/get-user-permissions";

interface PermissionGuardProps {
  permission: string | string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * PermissionGuard component - Renders children only if user has required permission
 * Use this to conditionally show/hide UI elements based on permissions
 * 
 * @example
 * <PermissionGuard permission="zone.manage">
 *   <button>Edit Zone</button>
 * </PermissionGuard>
 */
export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permission,
  children,
  fallback = null,
}) => {
  const hasAccess = hasPermissionSync(permission);
  
  if (!hasAccess) {
    return <>{fallback}</>;
  }
  
  return <>{children}</>;
};

export default PermissionGuard;
